import * as cosmosFunctions from './cosmos';
import { InstallError } from './error';
import * as tendermintFunctions from './tendermint';
export { InstallError };
export function isInstalled() {
    return !!window.cosmostation;
}
export function cosmos() {
    return new Promise(function (resolve, reject) {
        var interval = setInterval(function () {
            if (isInstalled()) {
                clearInterval(interval);
                resolve(cosmosFunctions);
            }
        }, 100);
        setTimeout(function () {
            clearInterval(interval);
            reject(new InstallError());
        }, 500);
    });
}
export function tendermint() {
    return new Promise(function (resolve, reject) {
        var interval = setInterval(function () {
            if (isInstalled()) {
                clearInterval(interval);
                resolve(tendermintFunctions);
            }
        }, 100);
        setTimeout(function () {
            clearInterval(interval);
            reject(new InstallError());
        }, 500);
    });
}
export function ethereum() {
    return new Promise(function (resolve, reject) {
        var interval = setInterval(function () {
            if (isInstalled()) {
                clearInterval(interval);
                resolve(window.cosmostation.ethereum);
            }
        }, 100);
        setTimeout(function () {
            clearInterval(interval);
            reject(new InstallError());
        }, 500);
    });
}
